import { ElementRef, EventEmitter, OnDestroy, OnInit, Renderer2 } from '@angular/core';
import { ControlValueAccessor, FormBuilder, FormGroup } from '@angular/forms';
import * as _ from 'lodash';
var SelectInputIndraComponent = /** @class */ (function () {
    function SelectInputIndraComponent(fb, renderer) {
        this.fb = fb;
        this.renderer = renderer;
        this.form = this.fb.group({
            select: [null]
        });
        this.label = '';
        this.selectLabel = '';
        this.placeholder = '';
        this.options = [];
        this.optionsTranslated = false;
        this.errorClass = '';
        this.isValueComplexObject = false;
        this.selectionChanged = new EventEmitter();
        // get openClass(): string {
        // 	return this.isOpen ? 'is-open' : '';
        // }
        this.propagateChange = function (n) { };
        this.onTouched = function (n) { };
        this.trackByFn = function (index, item) { return index; };
    }
    Object.defineProperty(SelectInputIndraComponent.prototype, "isLabel", {
        get: function () {
            return !_.isEmpty(this.label);
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(SelectInputIndraComponent.prototype, "value", {
        get: function () {
            return this._value;
        },
        set: function (value) {
            this._value = value;
            this.form.patchValue({ select: this.value }, { emitEvent: false });
            this.propagateChange(this.value);
            this.selectionChanged.emit(this.value);
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(SelectInputIndraComponent.prototype, "hasPlaceholder", {
        get: function () {
            return !_.isEmpty(this.placeholder);
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(SelectInputIndraComponent.prototype, "isUnselected", {
        get: function () {
            return this.hasPlaceholder ? 'is-unselected' : '';
        },
        enumerable: true,
        configurable: true
    });
    SelectInputIndraComponent.prototype.ngOnInit = function () {
        var _this = this;
        this.sub$ = this.form.get('select').valueChanges.subscribe(function (value) {
            _this.writeValue(value);
        });
    };
    SelectInputIndraComponent.prototype.ngOnDestroy = function () {
        if (this.sub$)
            this.sub$.unsubscribe();
    };
    SelectInputIndraComponent.prototype.writeValue = function (value) {
        if (!_.isEqual(this.value, value)) {
            this.value = value;
        }
    };
    SelectInputIndraComponent.prototype.registerOnChange = function (fn) {
        this.propagateChange = fn;
    };
    SelectInputIndraComponent.prototype.registerOnTouched = function (fn) {
        this.onTouched = fn;
    };
    SelectInputIndraComponent.prototype.setDisabledState = function (isDisabled) {
        if (isDisabled) {
            this.renderer.setAttribute(this.select.nativeElement, 'disabled', isDisabled);
        }
        else {
            this.renderer.removeAttribute(this.select.nativeElement, 'disabled');
        }
    };
    return SelectInputIndraComponent;
}());
export { SelectInputIndraComponent };
